import React, { useState, useEffect } from "react";
import Paper from "@mui/material/Paper";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TablePagination from "@mui/material/TablePagination";
import TableRow from "@mui/material/TableRow";
import { sortData, columns } from "./data";
import "./v-pass-table.css";
let pseudoCheckBoxSelectedData = [];

function VPassTable({ data, page, setPage, setCheckBoxSelectedData, setcsvData, setScreen }) {
  const [rowsPerPage, setRowsPerPage] = useState(10);

  const handleChangePage = (_event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };

  function setCSVFunction(data) {
    setcsvData([
      [
        "Vistor Name",
        "Resident Name",
        "Property Code",
        "Type",
        "Status",
        "Date",
        "Number of Guests",
        "Time In",
        "Time Out",
      ],
      ...data?.map(
        ({
          visitor_details,
          residentID,
          createdAt,
          active,
          number_of_persons,
          property_code,
          pass_type,
          arrival_date,
          departure_date,
        }) => {
          return [
            visitor_details?.first_name + ` ${visitor_details?.last_name}`,
            residentID?.first_name + ` ${residentID?.last_name}`,
            property_code || "none",
            pass_type || "Visitor",
            active ? "Pending" : "Expired",
            new Intl.DateTimeFormat("en-us", {
              year: "2-digit",
              month: "2-digit",
              day: "2-digit",
              hour: "2-digit",
              minute: "2-digit",
            }).format(new Date(createdAt)),
            number_of_persons || "-",
            arrival_date
              ? new Intl.DateTimeFormat("en-us", {
                  year: "2-digit",
                  month: "2-digit",
                  day: "2-digit",
                  hour: "2-digit",
                  minute: "2-digit",
                }).format(new Date(arrival_date))
              : "-",
            departure_date
              ? new Intl.DateTimeFormat("en-us", {
                  year: "2-digit",
                  month: "2-digit",
                  day: "2-digit",
                  hour: "2-digit",
                  minute: "2-digit",
                }).format(new Date(departure_date))
              : "-",
          ];
        }
      ),
    ]);
  }

  function makeChecboxComeAlive(event) {
    if (pseudoCheckBoxSelectedData.find((e) => e._id === event?.target?.getAttribute("data"))) {
      pseudoCheckBoxSelectedData = pseudoCheckBoxSelectedData.filter(
        (e) => e._id !== event?.target?.getAttribute("data")
      );
      setCheckBoxSelectedData(pseudoCheckBoxSelectedData);
      setCSVFunction(pseudoCheckBoxSelectedData);
    } else {
      pseudoCheckBoxSelectedData.push(
        data?.find((e) => e?._id === event?.target?.getAttribute("data"))
      );
      setCheckBoxSelectedData(pseudoCheckBoxSelectedData);
      setCSVFunction(pseudoCheckBoxSelectedData);
    }
  }

  useEffect(() => {
    document.querySelectorAll("#visitors-checkbox-children").forEach((element) => {
      if (pseudoCheckBoxSelectedData.find((e) => e._id === element?.getAttribute("data"))) {
        element.checked = true;
      } else element.checked = false;
    });
  });

  function allActionVistorsTable(add) {
    if (add) {
      pseudoCheckBoxSelectedData.length = 0;
      document.querySelectorAll("#visitors-checkbox-children").forEach((element) => {
        pseudoCheckBoxSelectedData.push(
          data?.find((e) => e?._id === element?.getAttribute("data"))
        );
        element.checked = true;
      });

      setCheckBoxSelectedData(pseudoCheckBoxSelectedData);

      setCSVFunction(pseudoCheckBoxSelectedData);
    } else {
      pseudoCheckBoxSelectedData.length = 0;
      document.querySelectorAll("#visitors-checkbox-children").forEach((element) => {
        element.checked = false;
      });
      setCSVFunction(data);
    }
  }

  if (!data) return;

  return (
    <Paper sx={{ width: "100%", overflow: "hidden", height: "fit-content" }}>
      <TableContainer sx={{ maxHeight: 440 }}>
        <Table stickyHeader aria-label="sticky table">
          <TableHead>
            <TableRow>
              {columns.map((column) => (
                <TableCell
                  key={column.id}
                  align={column.align}
                  style={{ minWidth: column.minWidth }}
                  onClick={(e) => {
                    if (e.target.className.includes("visitors-table-checkboxes-head")) {
                      if (!e.target.checked) allActionVistorsTable(false);
                      else allActionVistorsTable(true);
                    }
                  }}
                >
                  {column.label}
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {sortData(data)
              .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
              .map((row, i) => {
                return (
                  <TableRow hover role="checkbox" tabIndex={-1} key={i}>
                    {columns.map((column) => {
                      const value = row[column.id];
                      return (
                        <TableCell
                          style={{ cursor: "pointer" }}
                          onClick={(event) => {
                            if (event.target.className.includes("visitors-table-checkboxes")) {
                              event.stopPropagation();
                              return makeChecboxComeAlive(event);
                            }
                            setScreen({
                              screen: "details",
                              data: row?._id?.props["data-id"],
                            });
                          }}
                          key={column.id}
                          align={column.align}
                        >
                          {column.format && typeof value === "number"
                            ? column.format(value)
                            : value}
                        </TableCell>
                      );
                    })}
                  </TableRow>
                );
              })}
          </TableBody>
        </Table>
      </TableContainer>
      <TablePagination
        rowsPerPageOptions={[10, 25, 100]}
        component="div"
        count={sortData(data).length}
        rowsPerPage={rowsPerPage}
        page={page}
        onPageChange={handleChangePage}
        onRowsPerPageChange={handleChangeRowsPerPage}
      />
    </Paper>
  );
}

export { VPassTable, pseudoCheckBoxSelectedData };
